import { Component, computed, inject, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
	INSTITUTION_PERSON_SERVICE,
	provideInstitutionPersonService,
} from '../../../api/services/institution-person.service';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from '@angular/material/dialog';
import { NOTIFICATION_SERVICE } from '../../../shared/notification/notification';
import { createErrorNotification, createSuccessNotification } from '../../../shared/notification/notification.factory';
import { LvrField } from '../../../core/components/field/field';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { LvrInputDirective } from '../../../core/directives/lvr-input.directive';
import { LvrButton } from '../../../core/components/lvr-button/lvr-button';
import { Institution, InstitutionPerson } from '../../../api/app-types/institution.app';

@Component({
	selector: 'lvr-institution-person-deactivate-dialog',
	imports: [
		MatDialogTitle,
		MatDialogContent,
		MatDialogActions,
		MatDialogClose,
		TranslocoPipe,
		MatFormField,
		MatInput,
		FormsModule,
		LvrInputDirective,
		LvrField,
		LvrButton,
	],
	providers: [provideInstitutionPersonService],
	templateUrl: './institution-person-deactivate-dialog.html',
})
export class InstitutionPersonDeactivateDialog {
	private readonly api = inject(INSTITUTION_PERSON_SERVICE);
	private readonly ntfySrv = inject(NOTIFICATION_SERVICE);
	private readonly dialogRef = inject(MatDialogRef<InstitutionPersonDeactivateDialog>);
	private readonly data: { institution: Institution; person: InstitutionPerson; onDeactivated: () => Promise<void> } =
		inject(MAT_DIALOG_DATA);

	public readonly institution = this.data.institution;
	public readonly person = this.data.person;

	public readonly loading = signal(false);
	public readonly confirmationInput = signal('');
	public readonly isDeactivateEnabled = computed(() => {
		return this.confirmationInput().trim() === this.person.name.trim();
	});

	public async deactivatePerson() {
		if (!this.isDeactivateEnabled()) {
			return;
		}

		this.loading.set(true);

		try {
			await this.api.deactivatePerson(this.institution.id, this.person.id);
			await this.data.onDeactivated();
			this.ntfySrv.addNotification(
				createSuccessNotification(
					`Ansprechpartner ${this.person.firstName} ${this.person.name} wurde erfolgreich deaktiviert`,
				),
			);
			this.dialogRef.close(true);
		} catch {
			this.ntfySrv.addNotification(createErrorNotification('Fehler beim Deaktivieren des Ansprechpartners'));
		} finally {
			this.loading.set(false);
		}
	}
}
